import LayoutWithSidebar from "../components/LayoutWithSidebar";
import AdminSettingsSideMenu from "../components/AdminSettingsSideMenu";
import AdminInvoiceItemsListContainer from "../containers/AdminInvoiceItemsListContainer";
import MainHeaderContainer from "../containers/MainHeaderContainer";

const AdminInvoiceItemPage = () => {
  const headerContent = () => {
    return <MainHeaderContainer></MainHeaderContainer>;
  };

  const sidebarContent = () => {
    return <AdminSettingsSideMenu></AdminSettingsSideMenu>;
  };

  const contentPanelContent = () => {
    return <AdminInvoiceItemsListContainer></AdminInvoiceItemsListContainer>;
  };

  return (
    <LayoutWithSidebar
      headerContent={headerContent()}
      sidebarContent={sidebarContent()}
      mainPanelContent={contentPanelContent()}
    ></LayoutWithSidebar>
  );
};

export default AdminInvoiceItemPage;
